import keys from './key-module'
let keyValue = {
  ...keys,
  // 过滤器方法 eg: {this.$key.keyFilter(this.detailData.processState, 'purchase', 'processState').name}
  keyFilter: function (val, container, node, attr = 'id') {
    const param = keyValue[container][node].find((element) => {
      return element[attr] === val
    })
    return param
  },
  common: {
    validity: [
      {
        id: '1',
        name: '有效',
      },
      {
        id: '0',
        name: '无效',
      }
    ],
    market: [
      {
        id: '10102',
        name: '苹果'
      },
      {
        id: '10505',
        name: '辣椒'
      },
      {
        id: '10404',
        name: '好伙计'
      },
      {
        id: '10606',
        name: 'KA'
      },
      {
        id: '10506',
        name: '粮油'
      },
      {
        id: '90201',
        name: '农汇'
      },
      {
        id: '0',
        name: '默认市场'
      },
      {
        id: '10010',
        name: '板材'
      },
      {
        id: '10303',
        name: '茧丝'
      },
      {
        id: '000',
        name: '白糖'
      }
    ],
    interfaceStatus: [
      {
        id: '0',
        name: '全部'
      },
      {
        id: '1',
        name: '关闭'
      },
      {
        id: '2',
        name: '运行中'
      }
    ],
    limitType: [
      {
        id: '0',
        name: '不限制'
      },
      {
        id: '1',
        name: '日限制'
      },
      {
        id: '2',
        name: '月限制'
      },
      {
        id: '3',
        name: '年限制'
      }
    ],
    notification: [{
      id: '0',
      name: '模式一'
    }],
    sourceType: [
      {
        id: 'ORACLE',
        name: 'ORACLE'
      },
      {
        id: 'MYSQL',
        name: 'MYSQL'
      },
      {
        id: 'DB2',
        name: 'DB2'
      }
    ],
    syncType: [
      {
        id: '1',
        name: '全量'
      },
      {
        id: '2',
        name: '增量'
      },
      {
        id: '3',
        name: '全量&增量'
      }
    ],
    status: [
      {
        id: '0',
        name: '禁用'
      },
      {
        id: '1',
        name: '启用'
      }
    ],
    processStatus: [
      {
        id: 'N',
        name: '未开始'
      },
      {
        id: 'R',
        name: '进行中'
      },
      {
        id: 'P',
        name: '暂停'
      },
      {
        id: 'Y',
        name: '已完成'
      }
    ],
    isStatus: [
      {
        id: 'N',
        name: '异常'
      },
      {
        id: 'Y',
        name: '正常'
      }
    ]
  },
  myAccount: {
    // 交易状态
    tradeStatus: [
      {
        id: '20',
        name: '充值中'
      },
      {
        id: '30',
        name: '充值成功'
      },
      {
        id: '40',
        name: '充值失败'
      }
    ],
    paymentStatus: [
      {
        id: 'UN_REVIEW',
        name: '待审核'
      },
      {
        id: 'UN_PAID',
        name: '待支付'
      },
      {
        id: 'PAYING',
        name: '支付中'
      },
      {
        id: 'PAY_FAIL',
        name: '支付失败'
      },
      {
        id: 'PAY_SUCCESS',
        name: '支付成功'
      },
      {
        id: 'CANCELED',
        name: '已撤销'
      },
      {
        id: 'CANCELED_FAIL',
        name: '撤销失败'
      }
    ],
    // 审核状态
    auditStatus: [
      {
        id: '10',
        name: '待审核 ',
        class: 'green'
      },
      {
        id: '20',
        name: '审核通过',
        class: 'default'
      },
      {
        id: '30',
        name: '审核驳回',
        class: 'red'
      }
    ],
    transactionStatus: [
      {
        id: '10',
        name: '待支付'
      },
      {
        id: '20',
        name: '支付中'
      },
      {
        id: '30',
        name: '全部支付'
      },
      {
        id: '40',
        name: '支付失败'
      }
    ],
    // 渠道名称
    bankName: [{
      id: '001',
      name: '武汉众邦银行'
    },
    {
      id: '002',
      name: '京东金融'
    },
    {
      id: '003',
      name: '中信银行'
    },
    {
      id: '004',
      name: '京东金融'
    },
    {
      id: '005',
      name: '武汉众邦银行'
    },
    {
      id: '006',
      name: '武汉众邦银行'
    },
    {
      id: '007',
      name: '货款账户'
    }, {
      id: '008',
      name: '平安银行'
    },
    {
      id: '009',
      name: '茧丝卓尔金服'
    },
    {
      id: '010',
      name: '金融机构'
    }],
    // 流水类型
    flowType: [
      {
        id: 'DPT_FREEZE',
        name: '保证金冻结'
      },
      {
        id: 'DPT_RELEASE',
        name: '保证金解冻'
      },
      {
        id: 'DPT_DEDUCT',
        name: '保证金扣除'
      },
      {
        id: 'FEE_FREEZE',
        name: '手续费冻结'
      },
      {
        id: 'FEE_RELEASE',
        name: '手续费解冻'
      },
      {
        id: 'FEE_DEDUCT',
        name: '手续费收取'
      },
      {
        id: 'DPT_PT_IN',
        name: '线下普通充值'
      },
      {
        id: 'DPT_FHB_IN',
        name: '线下非货币充值'
      },
      {
        id: 'DPT_XS_IN',
        name: '线上普通充值'
      },
      {
        id: 'DPT_OUT',
        name: '线下普通提现'
      },
      {
        id: 'DPT_XS_OUT',
        name: '线上普通提现'
      },
    ],
    // 流水状态
    flowStatus: [
      {
        id: 'SUCCESS',
        name: '成功'
      },
      {
        id: 'FAILE',
        name: '失败'
      }, {
        id: 'PROCESS',
        name: '处理中'
      }
    ]
  },
  // 现货购销查询
  spotPurchaseSaleInquiry: {
    // 组织
    organization: [
      {
        id: '000',
        name: '沐甜市场'
      }
    ],
    // 订变
    entrustTs: [
      {
        id: 1,
        name: '订立'
      },
      {
        id: 2,
        name: '变更'
      }, {
        id: 3,
        name: '变今单'
      }
    ],
    // 委托类型
    entrustType: [
      {
        id: '0',
        name: '购销'
      },
      {
        id: '1',
        name: '套利'
      }
    ],
    // 委托方式
    entrustWay: [
      {
        id: '1',
        name: '自行委托'
      },
      {
        id: '2',
        name: '市场委托'
      },
      {
        id: '3',
        name: '强平委托'
      },
      {
        id: '4',
        name: '协议委托'
      }
    ],
    // 购销
    entrustBs: [
      {
        id: '1',
        name: '采购'
      },
      {
        id: '2',
        name: '销售'
      }
    ],
    // 交货状态
    statusEx: [
      {
        id: '0',
        name: '已移仓'
      },
      {
        id: '1',
        name: '已交收'
      },
      {
        id: '2',
        name: '已撤销'
      }
    ],
    // 交货方式
    deliveryMode: [
      {
        id: 'A',
        name: '提前交货'
      },
      {
        id: 'D',
        name: '到期交货'
      }
    ],
  },
  // 委托单
  transation: {
    // 报价方向/委托方向
    billType: [
      {
        id: 'BUY',
        name: '买'
      },
      {
        id: 'SELL',
        name: '卖'
      }
    ],
    // 委托状态
    entrustStatus: [
      {
        id: 'PRE',
        name: '未定价'
      },
      {
        id: 'PRICING',
        name: '已定价'
      },
      {
        id: 'MATCHING',
        name: '未成交'
      },
      {
        id: 'PART_MATCH',
        name: '部分成交'
      },
      {
        id: 'PART_CANCEL',
        name: '部分撤销'
      },
      {
        id: 'CANCEL',
        name: '已撤销'
      },
      {
        id: 'OK',
        name: '已成交'
      }
    ],
    // 成交总单状态
    orderStatus: [
      {
        id: 'WAIT',
        name: '未推送'
      },
      {
        id: 'PUSH',
        name: '已推合同'
      },
      {
        id: 'OK',
        name: '已完成'
      },
      {
        id: 'CANCEL',
        name: '已过期'
      },
      {
        id: 'BREAK',
        name: '已违约'
      }
    ],
    // 交易状态
    tradingStatus: [
      {
        id: 'PART_OK',
        name: '部分成交'
      },
      {
        id: 'ALL_OK',
        name: '全部成交'
      },
      {
        id: 'SUCCESS',
        name: '交易成功'
      },
      {
        id: 'OTHER_BREAK',
        name: '已完成'
      },
      {
        id: 'CANCEL',
        name: '已过期'
      },
      {
        id: 'BREAK',
        name: '已违约'
      }
    ],
  },
  contract: {
    // 合同状态 - 只给部分状态
    contractStatus: [
      {
        id: 'TO_AUTH',
        name: '待授权'
      },
      {
        id: 'TO_SIGN',
        name: '待签署'
      },
      {
        id: 'SIGNED',
        name: '已签署'
      },
      {
        id: 'INVALID',
        name: '作废'
      },
      // 只查上面三种状态的合同，下方三个状态先注释
      // {
      //   id: 'OUT_LINE',
      //   name: '稿件'
      // },
      // {
      //   id: 'TO_AUDIT',
      //   name: '待审核'
      // },
      // {
      //   id: 'REJECT',
      //   name: '已驳回'
      // },
    ]
  }
}
export default keyValue
